import { render, staticRenderFns } from "./HomeCripto.vue?vue&type=template&id=9ab12dba&scoped=true"
import script from "./HomeCripto.vue?vue&type=script&lang=ts"
export * from "./HomeCripto.vue?vue&type=script&lang=ts"
import style0 from "./HomeCripto.vue?vue&type=style&index=0&id=9ab12dba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ab12dba",
  null
  
)

export default component.exports